export default __webpack_public_path__ + "static/media/master-card.5d62b1cd.png";